"use strict";

import Vue from "vue";
import axios from "axios";

const baseURL =
  process.env.VUE_APP_BASE_URL ||
  process.env.VUE_APP_API_URL ||
  process.env.baseURL ||
  process.env.apiUrl;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers.post["Accept"] = "application/json";
axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = false;

let config = {
  baseURL,
  withCredentials: false,
};

const _axios = axios.create(config);

const applyAuthHeader = (config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = "Bearer " + token;
  } else if (config.headers && config.headers.Authorization) {
    delete config.headers.Authorization;
  }
  return config;
};

axios.interceptors.request.use(applyAuthHeader, function (error) {
  return Promise.reject(error);
});

_axios.interceptors.request.use(
  function (config) {
    return applyAuthHeader(config);
  },
  function (error) {
    return Promise.reject(error);
  },
);

_axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const Plugin = {
  install(Vue) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
      axios: {
        get() {
          return _axios;
        },
      },
      $axios: {
        get() {
          return _axios;
        },
      },
    });
  },
};

Vue.use(Plugin);

export { _axios, Plugin };
export default _axios;
